import React from "react";

export default function Top({ children }) {
  return (
    <section id="top-level" className="background-div">
      {children}
    </section>
  );
}
